export default "__VITE_ASSET__fUEY7p8u__"